var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 21H19C20.1 21 21 20.1 21 19V11H19V19H5V5H13V3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 14V16C7 16.55 7.45 17 8 17H10C10.27 17 10.52 16.89 10.71 16.71L18.36 9.06001L14.95 5.65001L7.3 13.3C7.20732 13.3935 7.13399 13.5043 7.08423 13.6261C7.03446 13.7479 7.00924 13.8784 7.01 14.01L7 14ZM20.71 6.71001C20.8027 6.6175 20.8763 6.50761 20.9264 6.38664C20.9766 6.26566 21.0024 6.13598 21.0024 6.00501C21.0024 5.87404 20.9766 5.74436 20.9264 5.62339C20.8763 5.50241 20.8027 5.39253 20.71 5.30001L18.71 3.30001C18.6175 3.20731 18.5076 3.13376 18.3866 3.08358C18.2656 3.0334 18.136 3.00757 18.005 3.00757C17.874 3.00757 17.7443 3.0334 17.6234 3.08358C17.5024 3.13376 17.3925 3.20731 17.3 3.30001L15.65 4.95001L19.06 8.36001L20.71 6.71001Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.81e76118b1ce394971fcd5d63a2583c5.svg";
export { ForwardRef as ReactComponent };